import { useEffect, useState } from 'react';

export const useIsFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(getIsInFullscreen());

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(getIsInFullscreen());
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, []);

  return isFullscreen;
};

export function getFullscreenIsSupported() {
  return !!(document.fullscreenEnabled ?? document.webkitFullscreenEnabled);
}

export function getIsInFullscreen() {
  return !!(document.fullscreenElement ?? document.webkitFullscreenElement);
}

export function requestFullscreen() {
  const documentElement = document.documentElement;

  if (documentElement.requestFullscreen) {
    documentElement.requestFullscreen();
  } else if (documentElement.webkitRequestFullScreen) {
    documentElement.webkitRequestFullScreen();
  }
}

export function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  }
}

declare global {
  // safari (< 16.4) uses prefixed versions of these stuff :(
  interface Document {
    webkitFullscreenEnabled?: boolean;
    webkitFullscreenElement?: Document['fullscreenElement'];
    webkitCancelFullScreen?: Document['exitFullscreen'];
  }

  interface HTMLElement {
    webkitRequestFullScreen?: HTMLElement['requestFullscreen'];
  }
}
